import { TableAction } from "features/shared/types/actions.table";
import { ItemSelectBehavior } from "features/shared/types/table";
import { useCallback } from "react";
import { useDispatch } from "services/redux/rootReducer";

const useClickHandlers = () => {
    const dispatch = useDispatch();

    const handleRowClick = useCallback(
        (e: React.MouseEvent, row: Record<string, any>, idx: number) => {
            e.stopPropagation();

            // metaKey = 'command' for MAC, 'windows' for Windows
            // ctrlKey = 'ctrl' for windows
            let itemSelectBehavior: ItemSelectBehavior;

            if (e.metaKey || e.ctrlKey) {
                itemSelectBehavior = ItemSelectBehavior.Checkbox;
            } else if (e.shiftKey) {
                itemSelectBehavior = ItemSelectBehavior.Range;
            } else {
                itemSelectBehavior = ItemSelectBehavior.Radio;
            }

            dispatch({
                type: TableAction.ADD_SELECTED_ITEM,
                item: row,
                idx,
                itemSelectBehavior,
            });
        },
        [dispatch]
    );

    const handleColumnClick = useCallback(
        (sortKey?: string) => {
            dispatch({
                type: TableAction.SET_SORT_KEY,
                sortKey,
            });
        },
        [dispatch]
    );

    const handleSelectAllClick = useCallback(() => {
        dispatch({
            type: TableAction.TOGGLE_SELECT_ALL_ITEMS,
        });
    }, [dispatch]);

    const handleSelectNoneClick = useCallback(() => {
        dispatch({
            type: TableAction.SET_SELECTED_ITEMS,
            selectedItems: [],
        });
    }, [dispatch]);

    return [
        handleRowClick,
        handleColumnClick,
        handleSelectAllClick,
        handleSelectNoneClick,
    ] as const;
};

export default useClickHandlers;
